module.exports = __webpack_public_path__ + "img/avatar.3af504bc.png";